var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{key:_vm.coverUrl,ref:"video",staticClass:"video-mux",attrs:{"width":"100%","controls":"true","preload":"metadata","poster":_vm.coverSrc},on:{"play":_vm.handlePlay}})
}
var staticRenderFns = []

export { render, staticRenderFns }